import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../../module_auth/AuthService"
import { useNavigate } from "react-router-dom"
import { CmtyBaseTableRow } from './CmtyBaseTableRow';
import { CTMY_REG_POST_URL } from './CmtyConstant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import '../../App.css'
import { useLocation } from "react-router-dom";
import { sendGoogleAnalytics } from "../common/BaseUtil"

export function CmtyHome() {
    const location = useLocation();

    const [jobPostList, setJobPostList] = useState([]);
    const [visaPostList, setVisaPostList] = useState([]);
    const [langPostList, setLangPostList] = useState([]);
    const [studyPostList, setStudyPostList] = useState([]);
    const [lifePostList, setLifePostList] = useState([]);
    const [housePostList, setHousePostList] = useState([]);
    const [healthcarePostList, setHealthcarePostList] = useState([]);
    const [insurancePostList, setInsurancePostList] = useState([]);
    const [bankPostList, setBankPostList] = useState([]);

    //const [bizPostList, setBizPostList] = useState([]);
    //const [marketPostList, setMarketPostList] = useState([]);
    //const [eventPostList, setEventPostList] = useState([]);
    //const [eatPostList, setEatPostList] = useState([]);
    //const [meetPostList, setMeetPostList] = useState([]);

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)
        
        loadEntities()
    }, []);
    
    function loadEntities(){
        let url = basePort + '/get/home/cmty/posts'
        fetch(url, 
            {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                setJobPostList(response.jobPostList)
                setVisaPostList(response.visaPostList)
                setLangPostList(response.langPostList)
                setStudyPostList(response.studyPostList)
                setLifePostList(response.lifePostList)
                setHousePostList(response.housePostList)
                setHealthcarePostList(response.healthcarePostList)
                setInsurancePostList(response.insurancePostList)
                setBankPostList(response.bankPostList)
                // console.log("response.healthcarePostList", response.healthcarePostList)
                // console.log("response.jobPostList", response.jobPostList)
                // console.log("response.visaPostList", response.visaPostList)
                //setBizPostList(response.bizPostList)
                //setMarketPostList(response.marketPostList)
                //setEventPostList(response.eventPostList)
                //setEatPostList(response.eatPostList)
                //setMeetPostList(response.meetPostList)
            }).catch(error => console.log(error))
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>커뮤니티</span></li>
                            <li class="breadcrumb-item"><span>홈</span></li>
                        </ol>
                    </div>
                    {/* JOB 취업 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_job?page=1">취업 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* BIZ 사업 */}
                    {/* <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_biz?page=1">사업 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bizPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    {/* VISA 비자 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_visa?page=1">비자 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visaPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* LANG 어학 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_lang?page=1">어학 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {langPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* STUDY 유학 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_study?page=1">유학 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studyPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* LIFE 생활 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_life?page=1">생활 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lifePostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* HOUSE 집 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_house?page=1">집 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {housePostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/*  MARKET 중고마켓 */}
                    {/* <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_market?page=1">중고마켓 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {marketPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    {/* EVENT 행사 */}
                    {/* <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_event?page=1">행사 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    {/* EAT 맛집 */}
                    {/* <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_eat?page=1">맛집 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eatPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    {/* MEET 친목 */}
                    {/* <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_meet?page=1">친목 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {meetPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    {/* HEALTHECARE 의료 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_healthcare?page=1">의료 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {healthcarePostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* INSURANCE 보험 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_insurance?page=1">보험 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {insurancePostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* BANK 은행 */}
                    <div class="container" style={{marginBottom: '30px'}}>
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" href="/cmty_bank?page=1">은행 <FontAwesomeIcon icon={faPlus}/></a>
                            </li>
                        </ul>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><FontAwesomeIcon icon={faPenToSquare} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faUser} /></th>
                                        <th className="community-table" style={{width: '100px'}}><FontAwesomeIcon icon={faEye} /></th>
                                        <th className="community-table" style={{width: '150px'}}><FontAwesomeIcon icon={faClock} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bankPostList.map((object, index) => (
                                        <CmtyBaseTableRow object={object} index={index}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                </section>
            </main>
        </div>
    );
}